import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tracks SPA route changes to GA4.
 * Skips admin routes (privacy + signal hygiene).
 * The initial page_view is fired by gtag config in index.html;
 * this component only sends subsequent route changes.
 */
export default function GAPageView() {
  const { pathname, search } = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    // Skip the very first render — index.html already fired it
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    if (pathname.startsWith("/admin")) return;

    const page_path = pathname + (search || "");
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
